module.exports = {
  AZ: "az", // Azerbaijani
  BG: "bg", // Bulgarian
  CS: "cs", // Czech
  DA: "da", // Danish
  DE: "de", // German
  EL: "el", // Greek
  EN: "en", // English
  EN_US: "en-US", // English (US)
  ES: "es", // Spanish
  ES_419: "es-419", // Latin American Spanish
  FR: "fr", // French
  FR_CA: "fr-CA", // Canadian French
  // HE: "he", // Hebrew
  ID: "id", // Indonesian
  IT: "it", // Italian
  // JA: "ja", // Japanese
  NB: "nb", // Norwegian Bokmål
  NL: "nl", // Dutch
  PL: "pl", // Polish
  PT: "pt", // Portuguese
  RO: "ro", // Romanian
  RU: "ru", // Russian
  SK: "sk", // Slovak
  TR: "tr", // Turkish
  UK: "uk", // Ukrainian
  UR: "ur", // Urdu
  ZH_TW: "zh-TW" // Chinese (Taiwan, Traditional)
};
